import { API_CONFIG } from './config';
import { api } from '../utils/apiClient';

export interface RegisteredUserOverview {
  email: string;
  name?: string | null;
  company?: string | null;
  inferred_company_domain?: string | null;
  registration_date?: string | null;
  last_activity_date?: string | null;
  number_of_projects: number;
  number_of_runs: number;
  cli_downloaded: boolean;
  api_used: boolean;
}

export interface CompanyDomainOverview {
  inferred_company_domain: string;
  number_of_registered_users: number;
  number_of_active_users: number;
  total_projects: number;
  total_runs: number;
  api_calls_last_7_days: number;
}

export interface AdminOverviewData {
  total_registered_users: number;
  new_users_today: number;
  new_users_last_7_days: number;
  total_projects: number;
  total_runs: number;
  runs_last_7_days: number;
  total_cli_downloads: number;
  cli_downloads_last_7_days: number;
  total_api_calls: number;
  api_calls_last_7_days: number;
  failed_runs_last_7_days: number;
  latest_registered_users: RegisteredUserOverview[];
  registered_users_by_company_domain: CompanyDomainOverview[];
  latest_signups: Record<string, unknown>[];
  latest_runs: Record<string, unknown>[];
  latest_cli_downloads: Record<string, unknown>[];
  latest_api_usage: Record<string, unknown>[];
}

const adminApiBase = API_CONFIG.BASE_URL.replace(/\/v1$/, '');

export const fetchAdminOverview = () =>
  api.get<AdminOverviewData>(`${adminApiBase}/admin/overview`);
